import { NgModule } from '@angular/core'
import { AppDownloadService } from './app-download.service'

@NgModule({
  providers: [AppDownloadService],
})
export class AppDownloadServiceModule {}
